import { Sales } from "../../../domain/projections/Sale";
import { SaleRepository } from "../../../domain/repositories/SaleRepository";
import { createHttpClients } from "../shared/createHttpClients";
import { mapSalesDTOtoSales } from "./responseMapper";

type SalesResponse = Parameters<typeof mapSalesDTOtoSales>[0];

class SaleRepositoryImpl implements SaleRepository {
  private static instance: SaleRepositoryImpl;

  private constructor() {}

  public static getInstance(): SaleRepositoryImpl {
    if (!SaleRepositoryImpl.instance) {
      SaleRepositoryImpl.instance = new SaleRepositoryImpl();
    }

    return SaleRepositoryImpl.instance;
  }

  public async get(auth: string, apiUrl: () => string): Promise<Sales> {
    try {
      const { httpPost } = createHttpClients(auth, apiUrl);
      const response = await httpPost<SalesResponse>({
        endpoint: `/sales/v1/view-recommendation`,
        body: {},
      });
      return mapSalesDTOtoSales(response);
    } catch (error) {
      return Promise.reject(error);
    }
  }
}

export { SaleRepositoryImpl };
